import React, { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { toLocalizedPath } from "../utils/i18nRoute";
import ResponsiveDrawer from "../components/ResponsiveDrawer";
import CircularLoading from "../components/CircularLoading";
import { useMfa } from "../contexts/MfaContext";
import { useThemeMode } from "../contexts/ThemeModeContext";

function matchUser(permit, usertype) {
  let permitions = permit ? permit.split(",") : [];
  let permitted = false;
  for (let i = 0; i < permitions.length; i++) {
    permitted = usertype === permitions[i] ? true : false;
    if (permitted) break;
  }
  return permitted;
}

function ProtectedRoute({ permit, children, darkMode: propDarkMode, toggleDarkMode: propToggleDarkMode, themeMode: propThemeMode }) {
  const contextTheme = useThemeMode();
  const darkMode = propDarkMode !== undefined ? propDarkMode : contextTheme.darkMode;
  const toggleDarkMode = propToggleDarkMode || contextTheme.toggleDarkMode;
  const themeMode = propThemeMode || contextTheme.themeMode;
  const auth = useSelector((state) => state.auth);
  const location = useLocation();
  const { i18n } = useTranslation();
  const [checkedAuth, setCheckedAuth] = useState(false);
  const { mfaEnrolled, mfaVerified, showMfaModal, setShowMfaModal } = useMfa();

  const isPrivileged = auth.profile?.usertype === "admin" || auth.profile?.usertype === "fleetadmin";
  const isMfaBlocked = isPrivileged && mfaEnrolled && !mfaVerified;

  useEffect(() => {
    if (auth.profile && auth.profile.uid) {
      setCheckedAuth(true);
    }
    if (auth.error && auth.error.msg && !auth.profile) {
      setCheckedAuth(true);
    }
  }, [auth.profile, auth.error]);

  useEffect(() => {
    if (checkedAuth && isMfaBlocked && !showMfaModal) {
      setShowMfaModal(true);
    }
  }, [checkedAuth, isMfaBlocked, showMfaModal, setShowMfaModal]);

  const isAuthValid = Boolean(
    auth.profile &&
    auth.profile.uid &&
    !auth.profile.accountDeleted &&
    !auth.profile.isDeleted &&
    !auth.accountDeleted &&
    !auth.isDeleted &&
    auth.error?.msg !== 'ACCOUNT_DELETED'
  );

  if (checkedAuth && isMfaBlocked) {
    return <CircularLoading />;
  }

  return checkedAuth ? (
    isAuthValid ? (
      matchUser(permit, auth.profile.usertype) ? (
        <ResponsiveDrawer darkMode={darkMode} toggleDarkMode={toggleDarkMode} themeMode={themeMode}>
          {React.cloneElement(children, { darkMode, toggleDarkMode, themeMode })}
        </ResponsiveDrawer>
      ) : (
        <Navigate 
          to={toLocalizedPath(
            auth.profile.usertype === "admin" || auth.profile.usertype === "fleetadmin" 
              ? "/dashboard" 
              : (auth.profile.usertype === "driver" ? "/overview" : "/"), 
            i18n.language
          )} 
          replace 
        />
      )
    ) : (
      <Navigate to={toLocalizedPath("/login", i18n.language)} state={{ from: location.pathname }} replace />
    )
  ) : (
    <CircularLoading />
  );
}

export default ProtectedRoute;
